import { Box, VStack, Text } from '@chakra-ui/react'
import { BrandBar } from '../../components/BrandBar'
import { TitleHeader } from '../../components/TitleHeader'
import { BackToCoinPurchaseLink } from './BackToCoinPurchaseLink'
import { ReturnButton } from './ReturnButton'
import { useLogout } from '../../hooks/useLogout'

export const PaymentErrorContent = ({ errorMessage, onBackToCoinPurchase, onReturnToApp, onLogoClick }) => {
  const { logout, isLoading: isLogoutLoading } = useLogout()

  return (
    <Box minH="100vh" bg="background.default" display="flex" justifyContent="center">
      <Box w="100%" maxW="500px" display="flex" flexDirection="column">
        <BrandBar onLogout={logout} isLogoutLoading={isLogoutLoading} onLogoClick={onLogoClick} />
        <TitleHeader title="決済エラー" />
        {/* メインコンテンツ（画面中央にメッセージ） */}
        <Box flex="1" display="flex" alignItems="center" justifyContent="center" px="16px">
          <Text fontSize="xl" color="label.primary" textAlign="center" lineHeight="1.5">
            {errorMessage}
          </Text>
        </Box>
        {/* フッター（画面下部に固定） */}
        <Box px="16px" pb="24px">
          <VStack spacing={4} align="stretch">
            <BackToCoinPurchaseLink onClick={onBackToCoinPurchase} />
            <ReturnButton onClick={onReturnToApp} />
          </VStack>
        </Box>
      </Box>
    </Box>
  )
}
